import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { useAuth } from './contexts/AuthContext';

// Layouts
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import QuoteRequest from './pages/QuoteRequest';
import QuoteHistory from './pages/QuoteHistory';
import QuoteDetails from './pages/QuoteDetails';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import ProviderDashboard from './pages/ProviderDashboard';
import WaitlistPage from './pages/WaitlistPage';
import LandingPage from './pages/LandingPage';

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  return (
    <>
      <CssBaseline />
      <Routes>
        {/* Public routes with auth layout */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Route>
        
        {/* Public home page with main layout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Home />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          
          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/request-quote" element={
            <ProtectedRoute>
              <QuoteRequest />
            </ProtectedRoute>
          } />
          
          <Route path="/quotes" element={
            <ProtectedRoute>
              <QuoteHistory />
            </ProtectedRoute>
          } />
          
          <Route path="/quotes/:id" element={
            <ProtectedRoute>
              <QuoteDetails />
            </ProtectedRoute>
          } />
          
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          
          <Route path="/provider-dashboard" element={
            <ProtectedRoute>
              <ProviderDashboard />
            </ProtectedRoute>
          } />
          
          {/* 404 page */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
